import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { ShuttleDialogData } from 'src/app/pages/management/tiersetup/tiersetup.component';

@Component({
    selector: 'app-add-shuttle-dialog',
    templateUrl: './add-shuttle-dialog.component.html',
    styleUrls: ['./add-shuttle-dialog.component.scss'],
    standalone: false
})
export class AddShuttleDialogComponent implements OnInit {
  heading: string;
  eventType: string;
  shuttleId: number;
  routeGroup: string
  minimumConnection: number
  fifo: any = ""
  unloadBased: any = ""
  tierId: number;
  errormsg: string;
  toggleIsFIFO: boolean = false;
  toggleIsUnloadBased: boolean = false;
  constructor(public dialogRef: MatDialogRef<AddShuttleDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: ShuttleDialogData, private readonly constants: Constants) { }

  ngOnInit(): void {

    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    if (this.eventType == 'EDIT') {  // NOSONAR
      this.shuttleId = this.dataStore.shuttleId
      this.routeGroup = this.dataStore.routeGroup
      this.minimumConnection = this.dataStore.minimumConnection
      this.fifo = this.dataStore.fifo
      this.unloadBased = this.dataStore.unloadBased
      this.tierId = this.dataStore.tierId
      this.toggleIsFIFO = this.fifo == 1 ? true : false;   // NOSONAR
      this.toggleIsUnloadBased = this.unloadBased == 1 ? true : false;   // NOSONAR
    }
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {
    this.errormsg = ""
    if (this.isValueOk(this.routeGroup)) {

      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.minimumConnection)) {

      this.showError(this.constants.formInputError);
    } else if (this.minimumConnection < 0) {

      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.tierId)) {

      this.showError(this.constants.formInputError);
    } else if (this.tierId < 0) {

      this.showError(this.constants.formInputError);
    } else {
      this.errormsg = ""
      this.fifo = this.toggleIsFIFO ? 1 : 0;
      this.unloadBased = this.toggleIsUnloadBased ? 1 : 0;
      this.dialogRef.close({
        event: "SaveEvent",
        eventType: this.eventType,
        shuttleId: this.shuttleId,
        routeGroup: this.routeGroup,
        minimumConnection: this.minimumConnection,
        fifo: this.fifo,
        unloadBased: this.unloadBased,
        tierId: this.tierId
      });
    }
  }


  showError(message) {
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTime);
  }
  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
{
      return true;
}
    return false;
  }


}
